<picture
    class="flex h-full relative overflow-hidden dark:from-dark-background to-gray-400 dark:to-dark-contrast before:absolute before:left-1/2 before:bottom-[30%] before:-translate-x-1/2 before:scale-x-[3] before:rounded-full before:bg-white/20 dark:before:bg-black/20 before:pt-[100%] before:pl-[100%] dark:after:bg-white/10"
    [ngClass]="{ 'min-h-[160px] bg-linear-to-r from-gray-300': (hasBrokenImage | async) }">
    @for (item of model?.sources; track $index) {
        <source
            [srcset]="item.url"
            [media]="item.mediaQuery" />
    }
    @if ((hasBrokenImage | async) === false) {
        <img
            class="relative object-cover w-full h-full"
            [src]="model?.defaultSourceUrl"
            [alt]="model?.altText"
            (error)="onError()" />
    }
</picture>
